export default "//cdn.scentbird.com/assets/frontbird-site/images/serum_205e0d.png";